import {
  MY_BOOKED_SPONSOR,
  FETCH_SPONSORS,
  FETCH_SPONSOR_DETAILS,
  SHOW_ONLY_SPONSOR_DETAILS
} from '../actions';
import { SET_SPONSOR } from '../actions';

export const myBookedSponsor = (state = {}, action) => {
  switch (action.type) {
    case MY_BOOKED_SPONSOR:
      return action.payload;
    default:
      return state;
  }
};

export const allSponsors_spn = (state = {}, action) => {
  switch (action.type) {
    case FETCH_SPONSORS:
      return action.payload;
    default:
      return state;
  }
};

export const sponsor = (state = null, action) => {
  switch (action.type) {
    case SET_SPONSOR:
      return action.payload;
    default:
      return state;
  }
};

export const sponsorDetails = (state = {}, action) => {
  switch (action.type) {
    case FETCH_SPONSOR_DETAILS:
      return action.payload;
    default:
      return state;
  }
};

export const showOnlySponsorDetailsReducer = (state = false, action) => {
  switch (action.type) {
    case SHOW_ONLY_SPONSOR_DETAILS:
      return action.payload;
    default:
      return state;
  }
};
